<template>
    <div>
        <div class="text-center my-4"
             v-if="fetchingProjects">
            <i class="fa fa-spin fa-sync-alt"></i>
        </div>
        <div class="text-danger font-size-sm p-3 text-center"
             v-else-if="fetchingError">
            {{fetchingError}}
        </div>

        <div v-else>
            <div class="text-muted font-size-sm p-3 text-center"
                 v-if="noNewProjects">
                You don't have any projects yet. <br/> Add one to start.
            </div>
            <div class="projects-parent" :class="{'loaded' : didFetchProjects}" ref="projectList">
                <b-dropdown-item class="mx-1 p-2" v-for="project in projectsStore.projects"
                                 :key="`${project.id}-${project.updated_at}`"
                                 @click="$emit('addToProject', project)">
                    <div class="d-flex justify-content-between align-items-center">
                        <div class="mr-4">
                            <i class="far fa-folder"/>
                            <span>{{project.name}}</span>
                        </div>

                        <div class="font-size-sm">
                            {{project.assets_count || 0}} {{project.assets_count === 1 ? 'item' : 'items'}}
                        </div>
                    </div>
                </b-dropdown-item>
            </div>

            <div class="bg-light mx-1 p-2" v-if="newProjectForm">
                <div class="d-flex justify-content-between align-items-center">
                    <div class="mr-4 d-flex align-items-center">
                        <i class="far fa-folder mr-1"/>
                        <b-form-input v-model="newProjectName"
                                      @keydown.enter.native.prevent.stop="saveNewProject"
                                      @keydown.esc.native.prevent.stop="resetNewProject"
                                      size="sm"
                                      class="new-project-name"
                                      placeholder="Project Name"
                                      autofocus/>
                    </div>

                    <div class="font-size-sm d-flex">
                        <i class="fas fa-times mr-1 cursor-pointer"
                           @click.stop="resetNewProject"/>
                        <i class="fas fa-check text-primary cursor-pointer"
                           @click.stop="saveNewProject"/>
                    </div>
                </div>

                <div class="text-danger font-size-sm mt-1"
                     v-if="newProjectError"
                     v-html="newProjectError"/>
            </div>

            <b-dropdown-divider/>

            <div class="bg-light p-2 mx-1 cursor-pointer text-primary"
                 :class="{'text-muted' : newProjectForm}"
                 @click="newProjectForm = true">
                <i class="fas fa-plus mr-1"/> Add a New Project
            </div>
        </div>
    </div>
</template>

<script>
  import normalize from "json-api-normalize";
  import Attributes from "../../models/Attributes";
  import GeneralMixins from "../../mixins/GeneralMixins";

  export default {
    props: ['bulkActionRunning', 'url'],
    data() {
      return {
        projectsStore: window.projectsStore,

        newProjectForm: false,
        newProjectName: '',
        newProjectError: null,

        didFetchProjects: false,
        fetchingProjects: false,
        fetchingError: null,
      }
    },

    methods: {
      fetchProjects() {
        // TODO: move this logic on the projects store
        if (!this.didFetchProjects && !this.fetchingProjects) {
          this.fetchingProjects = true;

          this.$http.get(this.url, {}).then(fulfilled => {
            try {
              this.projectsStore.projects = normalize(fulfilled.data).get(Attributes.projectAttributes);
              this.didFetchProjects = true;
              this.fetchingError = null;
            } catch (err) {
              console.log(err);
              this.fetchingError = "There was an error while getting your projects";
            }
          }, rejected => {
            console.log(rejected);
            this.fetchingError = "There was an error while getting your projects";
          }).then(() => {
            this.fetchingProjects = false;
          })
        }
      },

      resetNewProject: function () {
        this.newProjectForm = false;
        this.newProjectName = '';
        this.newProjectError = null;
      },

      saveNewProject() {
        this.$http.post(this.url, {
          name: this.newProjectName
        }).then(fulfilled => {
          const project = normalize(fulfilled.body).get(Attributes.projectAttributes);
          this.$set(this.projectsStore.projects, this.projectsStore.projects.length, project);
          this.resetNewProject();
          this.$nextTick(() => {
            const el = this.$refs.projectList;
            el.scrollTop = el.scrollHeight;
          });
        }, rejected => {
          this.newProjectError = this.getErrorMessagesHtml(rejected.body)
        })
      },
    },

    computed: {
      noNewProjects() {
        return !this.fetchingProjects && this.didFetchProjects && this.projectsStore.projects.length === 0 && !this.fetchingError;
      }
    },

    mixins: [GeneralMixins],
  }
</script>